import { useEffect, useContext, useState, FormEvent } from "react";
import { Button, Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";

import Spinner from "../../../shared/components/spinner/spinner";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { getAllData } from "../../../shared/utils/api";
import { validateLoadingStatusNew } from "../../../shared/utils/utils";
import NormalTable, { IColumn,ITableRowData } from "../normal-table/normal-table";
import "./user-popup.scss";

export interface IPopupConfig {
  mode: "Edit" | "New";
  columns: IColumn[];
  buttonText: string;
  show: boolean;
  unblockInput?: boolean;
  existingUsers?: ITableRowData[];
  dataUrl?: string;
  handlePopupClosed(result: ITableRowData[] | undefined): void;
}

const UserPopup = ({ mode,show, unblockInput, buttonText, dataUrl, existingUsers, columns, handlePopupClosed }: IPopupConfig ) => {
  const [validated, setValidated] = useState(false);
  const [allUsersData, setAllUsersData] = useState<{rows: ITableRowData[]}>();
  const [usersWithRoles, setUsersWithRoles] = useState<ITableRowData[]>();

  const authCtx = useContext(AuthContext);
  const { sendRequest: getAllDataRequest, status: allStatus, data: loadedData, error: errorGet } = useHttp(getAllData, false, authCtx.token);

  const getUsersWithRoles = (data: ITableRowData[]) => {
    setUsersWithRoles(data);
  };

  useEffect(() => {
    getAllDataRequest("users");
  }, []);

  useEffect(() => {
    if (allStatus === "completed" && !errorGet) {
      const existingUsersIds = existingUsers?.map((user) => user.id);
      const result = loadedData.rows.filter((user: ITableRowData) => existingUsersIds?.indexOf(user.id) === -1);
        
      setAllUsersData({rows: result});
    }
  }, [allStatus]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity()) {
      handlePopupClosed(usersWithRoles);
    }
    setValidated(true);
  };

  return (
    <div>
      <Modal className="UserPopup" show={show} onHide={() => handlePopupClosed(undefined)}>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>{mode === "New"? "Add" : "Edit"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {validateLoadingStatusNew([allStatus]) && <Spinner />}
            <NormalTable
              fetchedData={allUsersData}
              unblockInput={unblockInput}
              columns={columns}
              dataUrl={dataUrl}
              allStatus={allStatus}
              getSelectedRowsData={getUsersWithRoles}
              hideButtons={[]}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => handlePopupClosed(undefined)}
            >
              Close
            </Button>
            <Button
              className="UserPopup-action"
              type="submit"
              variant="primary"
            >
              {buttonText}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default UserPopup;
